export function resolveApiBaseUrl(
  env: ImportMetaEnv & { DEV?: boolean } = import.meta.env,
): string {
  // In Vite DEV, always use relative /api so VITE_API_PROXY works even when
  // frontend_spa/.env keeps a remote VITE_API_BASE_URL for production builds.
  if (env.DEV) return "/api";

  const base = env.VITE_API_BASE_URL?.trim() || "/api";
  return base.endsWith("/") ? base.slice(0, -1) : base;
}
